export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/files-icon.svg?28481aaacbd580bb4501f8040dcf607d";